export type Printer = {
  id: string;
  printerType: number;
  configuration: SlackPrinterConfig | TeamsPrinterConfig | UsbPrinterConfig | NetworkPrinterConfig | OfflinePrinterConfig;
  warehouseCode: string;
  printerClientId?: string;
  name: string;
  description: string;
  isDefaultForWarehouse: boolean;
  isConnected: boolean;
  type: PrinterTypeModel;
  enabled: boolean;
  printerClientName?: string;
};

export type PrinterItem = {
  name: string;
  id?: string;
};

export type SlackPrinterConfig = {
  $type: PrinterTypeModel.Slack;
  webHookUrl: string;
};
export type TeamsPrinterConfig = {
  $type: PrinterTypeModel.Teams;
  webHookUrl: string;
};
export type UsbPrinterConfig = {
  $type: PrinterTypeModel.Named;
  printerName: string;
};
export type NetworkPrinterConfig = {
  $type: PrinterTypeModel.Network;
  ipAddress: string;
  port: number;
};

export type OfflinePrinterConfig = {
  $type: PrinterTypeModel.Offline;
};

export type LabelPrint = {
  partId: number;
  printerId?: string;
};

export type PrinterClient = {
  id: string;
  name: string;
  lastConnected: string;
  description: string;
  isConnected: boolean;
};

export type PrinterClientList = PrinterClient[];

export enum PrinterType {
  Network = 'AEX.Inventory.LabelPrinting.Server.Controllers.AddPrinter+NetworkCommand, AEX.Inventory.LabelPrinting.Server',
  Named = 'AEX.Inventory.LabelPrinting.Server.Controllers.AddPrinter+NamedCommand, AEX.Inventory.LabelPrinting.Server',
  Slack = 'AEX.Inventory.LabelPrinting.Server.Controllers.AddPrinter+WebHookCommand, AEX.Inventory.LabelPrinting.Server',
  Teams = 'AEX.Inventory.LabelPrinting.Server.Controllers.AddPrinter+WebHookCommand, AEX.Inventory.LabelPrinting.Server',
  Debug = 'AEX.Inventory.LabelPrinting.Server.Controllers.AddPrinter+DebugCommand, AEX.Inventory.LabelPrinting.Server',
}

export enum PrinterTypeModel {
  Network = 'AEX.Inventory.LabelPrinting.Common.Models.NetworkPrinterConfiguration, AEX.Inventory.LabelPrinting.Common',
  Named = 'AEX.Inventory.LabelPrinting.Common.Models.UsbPrinterConfiguration, AEX.Inventory.LabelPrinting.Common',
  Slack = 'AEX.Inventory.LabelPrinting.Common.Models.SlackPrinterConfiguration, AEX.Inventory.LabelPrinting.Common',
  Teams = 'AEX.Inventory.LabelPrinting.Common.Models.TeamsPrinterConfiguration, AEX.Inventory.LabelPrinting.Common',
  Debug = 'AEX.Inventory.LabelPrinting.Common.Models.DebugPrinterConfiguration, AEX.Inventory.LabelPrinting.Common',
  Offline = 'Offline',
}

export enum EditPrinterType {
  Network = 'AEX.Inventory.LabelPrinting.Server.Controllers.UpdatePrinter+NetworkCommand, AEX.Inventory.LabelPrinting.Server',
  Named = 'AEX.Inventory.LabelPrinting.Server.Controllers.UpdatePrinter+NamedCommand, AEX.Inventory.LabelPrinting.Server',
  Slack = 'AEX.Inventory.LabelPrinting.Server.Controllers.UpdatePrinter+WebHookCommand, AEX.Inventory.LabelPrinting.Server',
  Teams = 'AEX.Inventory.LabelPrinting.Server.Controllers.UpdatePrinter+WebHookCommand, AEX.Inventory.LabelPrinting.Server',
  Debug = 'AEX.Inventory.LabelPrinting.Server.Controllers.UpdatePrinter+DebugCommand, AEX.Inventory.LabelPrinting.Server',
}

export enum WebHookPrinterType {
  Slack = 'Slack',
  Teams = 'Teams',
}
